import React, { useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import logo from "../assets/logo.webp";

const ROUTE_CONFIG = {
  "/home": { title: "Home", showLogoOnMobile: true },
  "/notifications": { title: "Notifications", showLogoOnMobile: true },
  "/settings": { title: "Settings", showLogoOnMobile: true },
  "/messages": { title: "Messages", showLogoOnMobile: true },
  "/pricing": { title: "Choose Your Plan", showLogoOnMobile: true },
  "/history": { title: "Linkups", showLogoOnMobile: true },
};

const TopNavBar = ({
  tabs = [],
  selectedTab = null,
  onChangeTab = () => {},
}) => {
  const { pathname } = useLocation();

  const config = useMemo(() => {
    // 1. Determine Border: Always show on desktop, hide on mobile home page
    const isMobile = window.innerWidth < 640; // sm breakpoint
    const showBottomBorder = !isMobile || pathname !== "/home";

    // 2. Determine Static Routes
    if (ROUTE_CONFIG[pathname]) {
      return { ...ROUTE_CONFIG[pathname], showBottomBorder };
    }

    // 3. Dynamic Routes
    let dynamicTitle = "";
    if (pathname.startsWith("/send-request/"))
      dynamicTitle = "Request a Linkup";
    else if (pathname.startsWith("/profile/")) dynamicTitle = "Profile";

    return {
      title: dynamicTitle,
      showLogoOnMobile: true,
      showBottomBorder,
    };
  }, [pathname]);

  const { title, showLogoOnMobile, showBottomBorder } = config;

  // Tap header to scroll to top (native app behavior)
  // const handleScrollToTop = useCallback(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  //   // Also try to scroll any virtualized list or main content area
  //   const mainContent =
  //     document.querySelector("[data-scroll-container]") ||
  //     document.querySelector(".feed-scroll-container") ||
  //     document.querySelector("main");
  //   if (mainContent) {
  //     mainContent.scrollTo({ top: 0, behavior: "smooth" });
  //   }
  // }, []);

  return (
    <header
      // onClick={handleScrollToTop}
      className={`relative top-0 z-50 w-full overflow-hidden bg-white cursor-pointer
        ${
          showBottomBorder
            ? "border-b border-black/[0.03] sm:border-black/5"
            : "border-b border-transparent"
        }`}
    >
      <div className="top-nav max-w-[1200px] mx-auto px-4 relative xr10">
        <div className="flex items-center justify-between h-12 sm:h-10 relative">
          <div className="flex items-center gap-2 sm:hidden">
            {showLogoOnMobile && (
              <img src={logo} alt="Logo" className="h-7 w-7 object-contain" />
            )}
            {title && (
              <span
                className="text-gray-900 font-bold tracking-tight"
                style={{
                  fontFamily: "'Baloo 2', cursive",
                  fontSize: "1.35rem",
                  lineHeight: 1,
                }}
              >
                {title}
              </span>
            )}
          </div>

          <div className="hidden sm:flex sm:absolute sm:inset-x-0 sm:justify-center">
            {title && (
              <span
                className="text-gray-900 font-semibold hidden sm:inline-block xl:hidden"
                style={{
                  fontFamily: "'Baloo 2', cursive",
                  fontSize: "1.5rem",
                }}
              >
                {title}
              </span>
            )}
          </div>
        </div>
      </div>

      {tabs.length > 0 && (
        <nav className="w-full overflow-x-auto relative z-10 border-t border-black/[0.03]">
          <div className="max-w-[1200px] mx-auto px-2 flex gap-1.5 py-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => onChangeTab(tab.id)}
                className={`whitespace-nowrap px-4 py-1.5 rounded-full text-[13px] font-bold transition-all duration-300 ${
                  selectedTab === tab.id
                    ? "bg-gray-900 text-white shadow-lg"
                    : "text-gray-500 hover:text-gray-800 hover:bg-black/5"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default TopNavBar;
